<!--{{fieldsFeaturesFast | json}}-->
<!--{{fieldsFeatures | json}}-->
<div class="selected-filters">
  <ng-container *ngFor="let item of fieldsFeaturesFast">
    <ng-container
      *ngIf="item.type=='select-multi-filter-property'||item.type=='multicheckbox-dam-fast-filter-property'">

      <ng-container>
        <div *ngFor="let itemMulti of item.defaultValue"
        >
          <ng-container
            *ngFor="let txt of item.templateOptions.options" [nbTooltip]="item.templateOptions.label">
            <div [nbTooltip]="item.templateOptions.label" class="filter-item"
                 (click)="deleteMulti(this.item.key, txt.value)" *ngIf="itemMulti==txt.value">{{ txt.label }}
              <nb-icon icon="close-outline"/>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngFor="let item of fieldsFeatures">
    <ng-container *ngIf="item.type=='checkbox-custom' && item.key!='hasStock'">
      <button style="margin-right: 1em; margin-top: 0.2em;" i18n-nbTooltip="@@RemoveFromFilter"
              nbTooltip="убрать из фильтра" (click)="delete(item.key)"
              *ngIf="item.defaultValue!=undefined && item.defaultValue!=false && item.fieldGroup==undefined" nbButton
              status="warning" size="tiny">
        {{ item.templateOptions.label }}:
        Да
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </ng-container>

    <ng-container *ngIf="item.type=='date-range-picker' && item.defaultValue!=undefined && item.defaultValue!=false && item.fieldGroup==undefined">
      <div [nbTooltip]="item.templateOptions.label" class="filter-item"
           (click)="delete(item.key)">
        от {{ item.defaultValue.from }} до {{ item.defaultValue.to }}
        <nb-icon icon="close-outline"/>
      </div>
    </ng-container>


    <ng-container
      *ngIf="item.type=='select-multi-filter-property'||item.type=='multicheckbox-filter-property' || item.type=='multicheckbox-filter-property'">
      <ng-container *ngIf="item.templateOptions.multipleValue">
        <ng-container *ngFor="let itemMulti of this.item.defaultValue">
          <div [nbTooltip]="item.templateOptions.label" class="filter-item"
               (click)="deleteMulti(this.item.key, itemMulti)">{{ getFeatureName(item.templateOptions.options, itemMulti) }}
            <nb-icon icon="close-outline"/>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!item.templateOptions.multipleValue && item.defaultValue!=null">
        <div
          class="filter-item"
          (click)="deleteMulti(this.item.key, item.defaultValue)"
        >
          {{ item.templateOptions.label }}:
          <ng-container *ngIf="item.defaultValue==='true'">Да</ng-container>
          <ng-container *ngIf="item.defaultValue==='false'">Нет</ng-container>
          <nb-icon icon="close-outline"/>
        </div>

      </ng-container>
    </ng-container>


    <ng-container *ngIf="item.type=='select-custom'">
      <button style="margin-right: 1em; margin-top: 0.2em;" i18n-nbTooltip="@@RemoveFromFilter"
              nbTooltip="убрать из фильтра" (click)="delete(item.key)"
              *ngIf="item.defaultValue!=undefined && item.defaultValue!=false && item.fieldGroup==undefined" nbButton
              status="warning" size="tiny">
        {{ item.templateOptions.label }}:
        {{ item.defaultValue.label }}
        <nb-icon icon="close-outline"></nb-icon>
      </button>

    </ng-container>


    <ng-container *ngIf="item.fieldGroup!=undefined">
      <button nbButton status="warning" size="tiny" i18n-nbTooltip="@@RemoveFromFilter" nbTooltip="убрать из фильтра"
              (click)="delete(item.key)" *ngIf="(item.fieldGroup[0].defaultValue!==undefined&&item.fieldGroup[0].defaultValue.length>0) ||
        (item.fieldGroup[1].defaultValue!==undefined&&item.fieldGroup[1].defaultValue.length>0)"
              style="margin-right: 1em">
        {{ item.templateOptions.label }}:
        <ng-container *ngFor="let itemGroup of item.fieldGroup">
          <ng-container *ngIf="itemGroup.key=='start'  && itemGroup.defaultValue!=''">
            от {{ itemGroup.defaultValue }}
          </ng-container>
          <ng-container *ngIf="itemGroup.key=='stop' && itemGroup.defaultValue!=''">
            до {{ itemGroup.defaultValue }}
          </ng-container>
        </ng-container>
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </ng-container>
  </ng-container>

  <button
    nbButton
    *ngIf="isFiltered()"
    (click)="reset()"
  >
    Очистить всё
  </button>
</div>
